import * as React from "react";

function SvgBugsnag(props, ref) {
  return (
    <svg width="1em" height="1em" viewBox="-5 5 70 50" {...{ ...props, ref }}>
      <defs>
        <linearGradient
          y2={10.838}
          x2={26.944}
          y1={58.853}
          x1={35.41}
          gradientUnits="userSpaceOnUse"
          id="bugsnag_svg__a"
        >
          <stop offset={0} stopColor="#628fbf" />
          <stop offset={1} stopColor="#689ace" />
        </linearGradient>
      </defs>
      <path
        d="M46.292 53.82H32.07c0-12.828-5.717-24.26-14.78-31.93l9.203-11.015a56.308 56.308 0 0119.8 42.946zm-8.087-35.277c7.25 9.9 11.573 22.03 11.573 35.277H64c0-16.314-5.298-31.373-14.222-43.643zM0 31.512c8.505 3.765 14.5 12.27 14.5 22.3h14.222A38.48 38.48 0 005.856 18.545z"
        fill="url(#bugsnag_svg__a)"
      />
    </svg>
  );
}

export default React.forwardRef(SvgBugsnag);
